const Freelances = () => {
    return (
      <div>
        <h1>Freelances 👩‍💻👨‍💻👩‍💻</h1>
      </div>
    )
  }
  
  export default Freelances
  